import React from "react";
import "../../css/App.scss";
import "../../css/SearchFilter.scss"
import PropTypes from 'prop-types';
import FullTextSearch from "./../Filter/FullTextSearch";
import LocationSearch from "./../Filter/LocationSearch";
import SearchButton from "../../Buttons/SearchButton";
import PositionListFiltered from "./../PositionList/PositionListFiltered";
import OtherSearchFilter from "../Filter/OtherSearchFilter";

export default class JobListWithFilter extends React.PureComponent {

    static propTypes = {
        customerName: PropTypes.string.isRequired,
        language: PropTypes.string.isRequired,
        customerData: PropTypes.objectOf(Promise).isRequired,
        positionList: PropTypes.objectOf(Promise).isRequired,
        agency: PropTypes.string
    };

    static defaultProps = {
        agency: null
    };

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
        };
        this.loadPositionListAndFilterSettings();
    }

    loadPositionListAndFilterSettings = () => {
        Promise.all([this.props.customerData, this.props.positionList])
            .then(([customerData, positionList]) => {
                this.setCompanies(positionList.result);
                this.setLocations(positionList.result);
                this.setState({
	                loading: false,
	                // workaround for bug
	                categorizePositions: customerData.result['gateSettings'] ? customerData.result['gateSettings']['categorize_positions'] : false,
	                filterSettings: customerData.result['gateSettings'],
	                positionList: positionList.result,
	                globalGateEnabled: this.props.isAgency ? false : positionList.globalGate,
                });
            });
    };

    setLocations = (joblist) => {
        let locations = {};
        Object.values(joblist).forEach(element => {
            if (element.hasOwnProperty('region') && element.region) {
                Object.entries(element.region).forEach(
                    function ([key, value]) {
                        locations[key] = value;
                    });
            }
        });
        let locationArray = [];
        Object.entries(locations).forEach(function ([key,value]) {
            locationArray.push({id: key, name: value});
        });
        this.setState({locations: locationArray});
    };

    setCompanies = (joblist) => {
        this.setState({
            companies: [...new Set(Object.values(joblist).map(item => item.companyName).filter(n => n))].map(function(item){ return {name: item, id: item}})
        });
    };

    changeSearchString = (event) => {
        this.setState({searchString: event.target.value});
    };

    changeLocationString = (event) => {
        this.setState({searchLocation: event.target.value})
    };

    changePositionTypeSelect = (event) => {
        this.setState({searchPositionType: event.target.value})
    };

    changeBusinessUnitSelect = (event) => {
        this.setState({searchBusinessUnit: event.target.value})
    };

    changeCompanySelect = (event) => {
        this.setState({searchCompany: event.target.value})
    };

    render() {
        if (this.state['loading']) {
            return null;
        }
        const { filterSettings: filter } = this.state;

        return (
            <>
                <div className="searchAndFilter-wrapper">
                    <div className="container">
                        {(this.state['filterSettings'] && (this.state['filterSettings'].fulltextSearch === '1' || this.state['filterSettings'].location === '1' || this.state['filterSettings'].other !== '0')) &&
                        <div className="row">
                            <div className="col">
                                <div className="searchAndFilter-block">
                                    <div className="searchAndFilter">
                                        <div className="search-form">
                                            <div className="row">
                                                <div className="col">
                                                    <div className="row">
                                                        {filter.fulltextSearch === '1' && (
                                                            <div className={'col-12 col-lg-' + (6 + (filter.location === '1' ? 0 : 3) + (filter.other !== '0' ? 0 : 3))}>
                                                                <FullTextSearch
                                                                    language={this.props.language}
                                                                    searchString={this.state['searchString']}
                                                                    onChange={this.changeSearchString}
                                                                    onSubmit={this.preventDefault}
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </div>
                                                        )}
                                                        {filter.location === '1' && (
                                                            <div className={'col-12 col-lg-' + (filter.fulltextSearch === '1' ? '3' : (filter.other !== '0' ? '6' : '12'))}>
                                                                <LocationSearch
                                                                    language={this.props.language}
                                                                    onChange={this.changeLocationString}
                                                                    locations={this.state['locations'] || []}
                                                                />
                                                            </div>)}
                                                        <OtherSearchFilter
                                                            type = {filter.other}
                                                            customerName={this.props.customerName}
                                                            companyOptions={this.state['companies']}
                                                            changePositionTypeSelect={this.changePositionTypeSelect}
                                                            changeBusinessUnitSelect={this.changeBusinessUnitSelect}
                                                            changeCompanySelect={this.changeCompanySelect}
                                                            language={this.props.language}
                                                            size={filter.fulltextSearch === '1' ? 3 : (filter.location === '1' ? 6 : 12)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-3 col-xl-2">
                                                    <SearchButton
                                                        customerName = {this.props.customerName}
                                                        language={this.props.language}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                <PositionListFiltered
                    language={this.props.language}
                    customerName={this.props.customerName}
                    positionList={this.state['positionList']}
                    searchString={this.state['searchString']}
                    searchLocation={this.state['searchLocation']}
                    searchBusinessUnit={this.state['searchBusinessUnit']}
                    searchCompany={this.state['searchCompany']}
                    searchPositionType={this.state['searchPositionType']}
                    globalGateEnabled={this.state.globalGateEnabled}
					categorizePositions={this.state.categorizePositions}
                    agency={this.props.agency}
                />
            </>
        )
    }
}
